var getWrapperId = (function (_ref) {
  var id = _ref.id;
  return id ? id + "-wrapper" : undefined;
});

export default getWrapperId;
